export const NAV_SET_URL_FILTERS = 'URL_FILTERS_SET';
export const NAV_UPDATE_URL_FILTERS = 'URL_FILTERS_LOAD';
